{
  "HELP_CENTER": {
    "TITLE": "Centar za pomoć",
    "NEW_PAGE": {
      "DESCRIPTION": "Izradite portale centra za pomoć za samostalno korištenje za svoje korisnike. Pomozite im da brzo pronađu odgovore, bez čekanja. Pojednostavite upite, povećajte učinkovitost agenata i podignite razinu korisničke podrške.",
      "CREATE_PORTAL_BUTTON": "Izradi portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Bez naslova"
    },
    "HEADER": {
      "FILTER": "Filtriraj po",
      "SORT": "Razvrstaj po",
      "LOCALE": "Jezik",
      "SETTINGS_BUTTON": "Postavke",
      "NEW_BUTTON": "Novi članak",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Objavljeno",
        "DRAFT": "Skica",
        "ARCHIVED": "Arhivirano"
      },
      "TITLES": {
        "ALL_ARTICLES": "Svi članci",
        "MINE": "Moji članci",
        "DRAFT": "Draft članci",
        "ARCHIVED": "Arhivirani članci"
      },
      "LOCALE_SELECT": {
        "TITLE": "Odaberite jezik",
        "PLACEHOLDER": "Odaberite jezik",
        "NO_RESULT": "Jezik nije pronađen",
        "SEARCH_PLACEHOLDER": "Pretraži jezik"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Svi članci",
      "PUBLISH_BUTTON": "Objavi",
      "MOVE_TO_ARCHIVE_BUTTON": "Premjesti u arhivu",
      "PREVIEW": "Pretpregled",
      "ADD_TRANSLATION": "Dodaj prijevod",
      "OPEN_SIDEBAR": "Otvori bočnu traku",
      "CLOSE_SIDEBAR": "Zatvori bočnu traku",
      "SAVING": "Spremanje...",
      "SAVED": "Spremljeno"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Prenesi sliku",
        "UPLOADING": "Prenosim...",
        "SUCCESS": "Slika je uspješno prenesena",
        "ERROR": "Pogreška prilikom prijenosa slike",
        "UN_AUTHORIZED_ERROR": "Niste ovlašteni za prijenos slika",
        "ERROR_FILE_SIZE": "Veličina slike mora biti manja od {size}MB",
        "ERROR_FILE_FORMAT": "Format slike mora biti jpg, jpeg ili png",
        "ERROR_FILE_DIMENSIONS": "Dimenzije slike moraju biti manje od 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Umetni sidro",
        "TITLE": "Umetni sidro",
        "SUBMIT": "Umetni",
        "PLACEHOLDER": "naziv-sidra"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Postavke članka",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategorija",
          "TITLE": "Odaberite kategoriju",
          "PLACEHOLDER": "Odaberite kategoriju",
          "NO_RESULT": "Kategorija nije pronađena",
          "SEARCH_PLACEHOLDER": "Pretraži kategoriju"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Odaberite autora",
          "PLACEHOLDER": "Odaberite autora",
          "NO_RESULT": "Autori nisu pronađeni",
          "SEARCH_PLACEHOLDER": "Pretraži autora"
        },
        "META_TITLE": {
          "LABEL": "Meta naslov",
          "PLACEHOLDER": "Dodajte meta naslov"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta opis",
          "PLACEHOLDER": "Dodajte meta opis za bolje SEO rezultate..."
        },
        "META_TAGS": {
          "LABEL": "Meta oznake",
          "PLACEHOLDER": "Dodajte meta oznake odvojene zarezom..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arhiviraj članak",
        "DELETE": "Izbriši članak"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Nekategorizirano",
      "SEARCH_RESULTS": "Rezultati pretrage za {query}",
      "EMPTY_TEXT": "Pretražite članke za umetanje u odgovore.",
      "SEARCH_LOADER": "Pretraživanje...",
      "INSERT_ARTICLE": "Umetni",
      "NO_RESULT": "Članci nisu pronađeni",
      "COPY_LINK": "Kopiraj poveznicu članka u međuspremnik",
      "OPEN_LINK": "Otvori članak u novoj kartici",
      "PREVIEW_LINK": "Pretpregled članka"
    },
    "PORTAL": {
      "HEADER": "Portali",
      "DEFAULT": "Zadano",
      "NEW_BUTTON": "Novi portal",
      "ACTIVE_BADGE": "aktivno",
      "CHOOSE_LOCALE_LABEL": "Odaberite jezik",
      "LOADING_MESSAGE": "Učitavanje portala...",
      "ARTICLES_LABEL": "članci",
      "NO_PORTALS_MESSAGE": "Nema dostupnih portala",
      "ADD_NEW_LOCALE": "Dodaj novi jezik",
      "POPOVER": {
        "TITLE": "Portali",
        "PORTAL_SETTINGS": "Postavke portala",
        "SUBTITLE": "Imate više portala i za svaki portal možete imati različite jezike.",
        "CANCEL_BUTTON_LABEL": "Odustani",
        "CHOOSE_LOCALE_BUTTON": "Odaberi jezik"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "članci",
            "ADD": "Dodaj jezik",
            "VISIT": "Posjeti stranicu",
            "SETTINGS": "Postavke",
            "DELETE": "Izbriši"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfiguracije portala",
            "ITEMS": {
              "NAME": "Ime",
              "DOMAIN": "Prilagođena domena",
              "SLUG": "Slug",
              "TITLE": "Naslov portala",
              "THEME": "Boja teme",
              "SUB_TEXT": "Podnaslov portala"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Dostupni jezici",
            "TABLE": {
              "NAME": "Naziv jezika",
              "CODE": "Kod jezika",
              "ARTICLE_COUNT": "Broj članaka",
              "CATEGORIES": "Broj kategorija",
              "SWAP": "Zamijeni",
              "DELETE": "Izbriši",
              "DEFAULT_LOCALE": "Zadano"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Izbriši portal",
          "MESSAGE": "Jeste li sigurni da želite izbrisati ovaj portal",
          "YES": "Da, izbriši portal",
          "NO": "Ne, zadrži portal",
          "API": {
            "DELETE_SUCCESS": "Portal je uspješno izbrisan",
            "DELETE_ERROR": "Pogreška prilikom brisanja portala"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Uredi portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Osnovne informacije"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Prilagodba portala"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorije"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Jezici"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorije u",
          "NEW_CATEGORY": "Nova kategorija",
          "TABLE": {
            "NAME": "Ime",
            "DESCRIPTION": "Opis",
            "LOCALE": "Jezik",
            "ARTICLE_COUNT": "Broj članaka",
            "ACTION_BUTTON": {
              "EDIT": "Uredi kategoriju",
              "DELETE": "Izbriši kategoriju"
            },
            "EMPTY_TEXT": "Nisu pronađene kategorije"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Ažuriraj osnovne postavke"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informacije o centru za pomoć",
            "BODY": "Osnovne informacije o portalu"
          },
          "CUSTOMIZATION": {
            "TITLE": "Prilagodba centra za pomoć",
            "BODY": "Prilagodi portal"
          },
          "FINISH": {
            "TITLE": "Gotovo! 🎉",
            "BODY": "Sve je spremno!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Natrag",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Izradi portal",
            "TITLE": "Informacije o centru za pomoć",
            "CREATE_BASIC_SETTING_BUTTON": "Izradi osnovne postavke portala"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Prilagodba portala",
            "TITLE": "Prilagodba centra za pomoć",
            "UPDATE_PORTAL_BUTTON": "Ažuriraj postavke portala"
          },
          "FINISH_PAGE": {
            "TITLE": "Gotovo! 🎉 Sve je spremno!",
            "MESSAGE": "Sada možete vidjeti ovaj izrađeni portal na stranici sa svim portalima.",
            "FINISH": "Idi na stranicu sa svim portalima"
          }
        },
        "LOGO": {
          "LABEL": "Logotip",
          "UPLOAD_BUTTON": "Prenesi logotip",
          "HELP_TEXT": "Ovaj logotip prikazivat će se u zaglavlju portala.",
          "IMAGE_UPLOAD_SUCCESS": "Logotip je uspješno prenesen",
          "IMAGE_UPLOAD_ERROR": "Logotip je uspješno izbrisan",
          "IMAGE_DELETE_ERROR": "Pogreška prilikom brisanja logotipa"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv portala",
          "HELP_TEXT": "Naziv će se interno koristiti na javnom portalu.",
          "ERROR": "Ime je obavezno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portala za URL-ove",
          "ERROR": "Slug je obavezan"
        },
        "DOMAIN": {
          "LABEL": "Prilagođena domena",
          "PLACEHOLDER": "Prilagođena domena portala",
          "HELP_TEXT": "Dodajte samo ako želite koristiti prilagođenu domenu za svoje portale. Npr.: {exampleURL}",
          "ERROR": "Unesite valjani URL domene"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Poveznica početne stranice",
          "PLACEHOLDER": "Poveznica početne stranice portala",
          "HELP_TEXT": "Poveznica koja se koristi za povratak s portala na početnu stranicu. Npr.: {exampleURL}",
          "ERROR": "Unesite valjani URL početne stranice"
        },
        "THEME_COLOR": {
          "LABEL": "Boja teme portala",
          "HELP_TEXT": "Ova boja prikazivat će se kao boja teme portala."
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov stranice",
          "PLACEHOLDER": "Naslov stranice portala",
          "HELP_TEXT": "Naslov stranice koristit će se na javnom portalu.",
          "ERROR": "Naslov stranice je obavezan"
        },
        "HEADER_TEXT": {
          "LABEL": "Tekst zaglavlja",
          "PLACEHOLDER": "Tekst zaglavlja portala",
          "HELP_TEXT": "Tekst zaglavlja portala koristit će se na javnom portalu.",
          "ERROR": "Tekst zaglavlja portala je obavezan"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal je uspješno izrađen.",
          "ERROR_MESSAGE_FOR_BASIC": "Portal nije moguće izraditi. Pokušajte ponovno.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal je uspješno ažuriran.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portal nije moguće ažurirati. Pokušajte ponovno."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Dodaj novi jezik",
        "SUB_TITLE": "Ovime se dodaje novi jezik na vaš popis dostupnih prijevoda.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Jezik",
          "PLACEHOLDER": "Odaberite jezik",
          "ERROR": "Jezik je obavezan"
        },
        "BUTTONS": {
          "CREATE": "Izradi jezik",
          "CANCEL": "Odustani"
        },
        "API": {
          "SUCCESS_MESSAGE": "Jezik je uspješno dodan",
          "ERROR_MESSAGE": "Jezik nije moguće dodati. Pokušajte ponovno."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Zadani jezik je uspješno ažuriran",
          "ERROR_MESSAGE": "Zadani jezik nije moguće ažurirati. Pokušajte ponovno."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Jezik je uspješno uklonjen s portala",
          "ERROR_MESSAGE": "Jezik nije moguće ukloniti s portala. Pokušajte ponovno."
        }
      }
    },
    "TABLE": {
      "404": "Nijedan članak ne odgovara vašoj pretrazi 🔍",
      "LOADING_MESSAGE": "Učitavanje članaka...",
      "NO_ARTICLES": "Nema dostupnih članaka",
      "HEADERS": {
        "TITLE": "Naslov",
        "CATEGORY": "Kategorija",
        "READ_COUNT": "Pregledi",
        "STATUS": "Status",
        "LAST_EDITED": "Zadnja izmjena"
      },
      "COLUMNS": {
        "BY": "od",
        "AUTHOR_NOT_AVAILABLE": "Autor nije dostupan"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Učitavanje članka...",
      "TITLE_PLACEHOLDER": "Ovdje unesite naslov članka",
      "CONTENT_PLACEHOLDER": "Ovdje napišite svoj članak",
      "API": {
        "ERROR": "Pogreška prilikom spremanja članka"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Pogreška prilikom objavljivanja članka",
        "SUCCESS": "Članak je uspješno objavljen"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Pogreška prilikom arhiviranja članka",
        "SUCCESS": "Članak je uspješno arhiviran"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Pogreška prilikom spremanja članka kao drafta",
        "SUCCESS": "Članak je uspješno spremljen kao draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potvrdi brisanje",
          "MESSAGE": "Jeste li sigurni da želite izbrisati članak?",
          "YES": "Da, izbriši",
          "NO": "Ne, zadrži"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Članak je uspješno izbrisan",
        "ERROR_MESSAGE": "Pogreška prilikom brisanja članka"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Dodajte naslov i sadržaj članka kako biste mogli ažurirati postavke"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Pretraži članke"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Izradi kategoriju",
        "SUB_TITLE": "Kategorija će se koristiti na javnom portalu za kategorizaciju članaka.",
        "PORTAL": "Portal",
        "LOCALE": "Jezik",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv kategorije",
          "HELP_TEXT": "Naziv i ikona kategorije koristit će se na javnom portalu za kategorizaciju članaka.",
          "ERROR": "Ime je obavezno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorije za URL-ove",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je obavezan"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Unesite kratak opis kategorije.",
          "ERROR": "Opis je obavezan"
        },
        "BUTTONS": {
          "CREATE": "Izradi kategoriju",
          "CANCEL": "Odustani"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je uspješno izrađena",
          "ERROR_MESSAGE": "Kategoriju nije moguće izraditi"
        }
      },
      "EDIT": {
        "TITLE": "Uredi kategoriju",
        "SUB_TITLE": "Uređivanjem kategorije ažurirat će se kategorija na javnom portalu.",
        "PORTAL": "Portal",
        "LOCALE": "Jezik",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv kategorije",
          "HELP_TEXT": "Naziv i ikona kategorije koristit će se na javnom portalu za kategorizaciju članaka.",
          "ERROR": "Ime je obavezno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorije za URL-ove",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je obavezan"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Unesite kratak opis kategorije.",
          "ERROR": "Opis je obavezan"
        },
        "BUTTONS": {
          "CREATE": "Ažuriraj kategoriju",
          "CANCEL": "Odustani"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je uspješno ažurirana",
          "ERROR_MESSAGE": "Kategoriju nije moguće ažurirati"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je uspješno izbrisana",
          "ERROR_MESSAGE": "Kategoriju nije moguće izbrisati"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Pretraži članke",
      "PLACEHOLDER": "Pretraži članke",
      "NO_RESULT": "Članci nisu pronađeni",
      "SEARCHING": "Pretraživanje...",
      "SEARCH_BUTTON": "Pretraži",
      "INSERT_ARTICLE": "Umetni poveznicu",
      "IFRAME_ERROR": "URL je prazan ili nevažeći. Sadržaj se ne može prikazati.",
      "OPEN_ARTICLE_SEARCH": "Umetni članak iz centra za pomoć",
      "SUCCESS_ARTICLE_INSERTED": "Članak je uspješno umetnut",
      "PREVIEW_LINK": "Pretpregled članka",
      "CANCEL": "Zatvori",
      "BACK": "Natrag",
      "BACK_RESULTS": "Natrag na rezultate"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centar za pomoć",
      "DESCRIPTION": "Izradite jednostavne portale za samostalno korištenje. Pomozite svojim korisnicima da pristupe člancima i dobiju podršku 24/7. Nadogradite svoju pretplatu kako biste omogućili ovu značajku.",
      "SELF_HOSTED_DESCRIPTION": "Izradite jednostavne portale za samostalno korištenje. Pomozite svojim korisnicima da pristupe člancima i dobiju podršku 24/7. Obratite se svom administratoru kako biste omogućili ovu značajku.",
      "BUTTON": {
        "LEARN_MORE": "Saznaj više",
        "UPGRADE": "Nadogradi"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Više portala",
          "DESCRIPTION": "Izradite više portala centra za pomoć za različite proizvode koristeći isti račun."
        },
        "LOCALES": {
          "TITLE": "Potpuna podrška za jezike",
          "DESCRIPTION": "Lokalizirajte portal na svoj jezik. Podržavamo sve jezike i omogućujemo prijevode za svaki članak."
        },
        "SEO": {
          "TITLE": "SEO prilagođen dizajn",
          "DESCRIPTION": "Prilagodite svoje meta oznake kako biste poboljšali vidljivost na tražilicama pomoću naših SEO prilagođenih stranica."
        },
        "API": {
          "TITLE": "Potpuna podrška za API",
          "DESCRIPTION": "Koristite portal kao headless CMS s vanjskim front-end okvirima putem naših API-ja."
        }
      }
    },
    "LOADING": "Učitavanje...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} pregled | {count} pregleda",
          "DROPDOWN_MENU": {
            "PUBLISH": "Objavi",
            "DRAFT": "Skica",
            "ARCHIVE": "Arhiviraj",
            "DELETE": "Izbriši"
          },
          "STATUS": {
            "DRAFT": "Skica",
            "PUBLISHED": "Objavljeno",
            "ARCHIVED": "Arhivirano"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Nekategorizirano"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Svi članci",
          "MINE": "Moji",
          "DRAFT": "Skica",
          "PUBLISHED": "Objavljeno",
          "ARCHIVED": "Arhivirano"
        },
        "CATEGORY": {
          "ALL": "Sve kategorije"
        },
        "LOCALE": {
          "ALL": "Svi jezici"
        },
        "NEW_ARTICLE": "Novi članak"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Napiši članak",
          "SUBTITLE": "Napišite sadržajan članak, krenimo!",
          "BUTTON_LABEL": "Novi članak"
        },
        "MINE": {
          "TITLE": "Ovdje još niste napisali nijedan članak",
          "SUBTITLE": "Svi članci koje ste napisali prikazuju se ovdje radi brzog pristupa."
        },
        "DRAFT": {
          "TITLE": "Nema članaka u draftovima",
          "SUBTITLE": "Draft članci pojavit će se ovdje"
        },
        "PUBLISHED": {
          "TITLE": "Nema objavljenih članaka",
          "SUBTITLE": "Objavljeni članci prikazivat će se ovdje"
        },
        "ARCHIVED": {
          "TITLE": "Nema članaka u arhivi",
          "SUBTITLE": "Arhivirani članci se ne prikazuju na portalu, možete ih koristiti za označavanje zastarjelih stranica"
        },
        "CATEGORY": {
          "TITLE": "Nema članaka u ovoj kategoriji",
          "SUBTITLE": "Članci u ovoj kategoriji prikazivat će se ovdje"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nova kategorija",
        "EDIT_CATEGORY": "Uredi kategoriju",
        "CATEGORIES_COUNT": "{n} kategorija | {n} kategorija",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorije ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} članaka) | {categoryName} ({categoryCount} članak)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nisu pronađene kategorije",
        "SUBTITLE": "Kategorije će se prikazivati ovdje. Kategoriju možete dodati klikom na gumb 'Nova kategorija'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} članak | {count} članaka",
        "EXPAND": "Prikaži podkategorije",
        "COLLAPSE": "Sakrij podkategorije",
        "MENU": {
          "NEW_ARTICLE": "Novi članak",
          "ADD_SUBCATEGORY": "Dodaj podkategoriju",
          "EDIT": "Uredi",
          "DELETE": "Izbriši"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je uspješno izrađena",
            "ERROR_MESSAGE": "Kategoriju nije moguće izraditi"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je uspješno ažurirana",
            "ERROR_MESSAGE": "Kategoriju nije moguće ažurirati"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je uspješno izbrisana",
            "ERROR_MESSAGE": "Kategoriju nije moguće izbrisati"
          },
          "CONFIRM": {
            "TITLE": "Izbriši kategoriju",
            "DESCRIPTION": "Jeste li sigurni da želite izbrisati ovu kategoriju? Njezini članci postat će nekategorizirani.",
            "DESCRIPTION_WITH_CHILDREN": "Jeste li sigurni da želite izbrisati ovu kategoriju? Njezini članci postat će nekategorizirani, a njezina {count} podkategorija bit će premještena na najvišu razinu. | Jeste li sigurni da želite izbrisati ovu kategoriju? Njezini članci postat će nekategorizirani, a njezine {count} podkategorije bit će premještene na najvišu razinu.",
            "CONFIRM": "Izbriši"
          }
        },
        "HEADER": {
          "CREATE": "Izradi kategoriju",
          "EDIT": "Uredi kategoriju",
          "DESCRIPTION": "Uređivanjem kategorije ažurirat će se kategorija na javnom portalu.",
          "PORTAL": "Portal",
          "LOCALE": "Jezik"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Ime",
            "PLACEHOLDER": "Naziv kategorije",
            "ERROR": "Ime je obavezno"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategorije za URL-ove",
            "ERROR": "Slug je obavezan",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Unesite kratak opis kategorije.",
            "ERROR": "Opis je obavezan"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Nadređena kategorija",
            "PLACEHOLDER": "Odaberite nadređenu kategoriju",
            "NONE": "Nijedna (najviša razina)"
          }
        },
        "BUTTONS": {
          "CREATE": "Izradi",
          "EDIT": "Ažuriraj",
          "CANCEL": "Odustani"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Nema dostupnih jezika | {n} jezik | {n} jezika",
      "NEW_LOCALE_BUTTON_TEXT": "Novi jezik",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} članak | {count} članaka",
        "CATEGORIES_COUNT": "{count} kategorija | {count} kategorija",
        "DEFAULT": "Zadano",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Postavi kao zadano",
          "DELETE": "Izbriši"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Dodaj novi jezik",
        "DESCRIPTION": "Odaberite jezik na kojem će ovaj članak biti napisan. Bit će dodan na vaš popis prijevoda, a kasnije možete dodati još.",
        "COMBOBOX": {
          "PLACEHOLDER": "Odaberite jezik..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Jezik je uspješno dodan",
          "ERROR_MESSAGE": "Jezik nije moguće dodati. Pokušajte ponovno."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Spremanje...",
          "SAVED": "Spremljeno"
        },
        "PREVIEW": "Pretpregled",
        "PUBLISH": "Objavi",
        "DRAFT": "Skica",
        "ARCHIVE": "Arhiviraj",
        "BACK_TO_ARTICLES": "Natrag na članke"
      },
      "DRAFT": {
        "PENDING_LABEL": "Neobjavljene promjene",
        "PROMOTE": "Objavi promjene",
        "DISCARD": "Odbaci promjene",
        "PROMOTE_SUCCESS": "Promjene skice objavljene su u aktivnom članku",
        "PROMOTE_ERROR": "Nije moguće objaviti promjene skice",
        "DISCARD_SUCCESS": "Promjene skice odbačene",
        "DISCARD_ERROR": "Nije moguće odbaciti promjene skice"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Povijest verzija",
        "TITLE": "Povijest verzija",
        "BACK": "Natrag na članak",
        "LOADING": "Učitavanje verzija...",
        "EMPTY": "Još nema verzija. Izmjene ovog članka pojavit će se ovdje.",
        "EMPTY_CONTENT": "Ova verzija nema sadržaja.",
        "CURRENT_BADGE": "Trenutna",
        "RESTORED_BADGE": "Vraćena",
        "AUTOMATED_USER": "Automatsko ažuriranje",
        "RESTORE": "Vrati ovu verziju",
        "RESTORE_DIALOG": {
          "TITLE": "Vratiti ovu verziju?",
          "DESCRIPTION": "Članak će se vratiti na tekst ove verzije. Ništa se ne gubi — trenutni tekst ostaje u povijesti, a ako je članak već objavljen, javna stranica i dalje prikazuje aktivnu verziju dok ne objavite ovu promjenu.",
          "CONFIRM": "Vrati"
        },
        "RESTORE_SUCCESS": "Verzija vraćena",
        "RESTORE_ERROR": "Nije moguće vratiti ovu verziju",
        "FETCH_ERROR": "Nije moguće učitati povijest verzija"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Više svojstava",
        "TRANSLATE": "Prevedi",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Nekategorizirano",
        "EDITOR_PLACEHOLDER": "Napišite nešto...",
        "HTML_EMBED": {
          "TITLE": "Umetni prilagođeni HTML",
          "DESCRIPTION": "Zalijepite čisti HTML poput iframea, embeda ili widget isječka. Prikazat će se onakav kakav jest u objavljenom članku.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Umetni"
        },
        "PRIMARY_CATEGORY": "Primarna kategorija"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Svojstva članka",
        "SLUG": "Slug",
        "EDIT_SLUG": "Uredi slug",
        "META_DESCRIPTION": "Meta opis",
        "META_DESCRIPTION_PLACEHOLDER": "Dodaj meta opis",
        "META_TITLE": "Meta naslov",
        "META_TITLE_PLACEHOLDER": "Dodaj meta naslov",
        "META_TAGS": "Meta oznake",
        "META_TAGS_PLACEHOLDER": "Dodaj meta oznake",
        "SET_AS_HOMEPAGE": "Postavi kao početnu stranicu",
        "SET_AS_HOMEPAGE_HELP": "Prikaži ovaj članak kao početnu stranicu centra za pomoć za ovaj jezik. Dodajte {'{{NAV}}'} u sadržaj da biste uključili pretraživanje i kategorije.",
        "LANGUAGE_MUTATIONS": "Jezične varijante",
        "LANGUAGE_MUTATIONS_EMPTY": "Još nema povezanih članaka",
        "ADD_MUTATION": "Dodaj",
        "REMOVE_MUTATION": "Ukloni"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Poveži jezične varijante",
        "SEARCH_PLACEHOLDER": "Pretraži članke po naslovu",
        "EMPTY": "Nema podudarnih članaka",
        "CANCEL": "Otkaži",
        "ADD_SELECTED": "Dodaj odabrane",
        "SUCCESS": "Varijante ažurirane",
        "ERROR": "Ažuriranje varijanti nije uspjelo"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Prevedi članak",
        "DESCRIPTION": "Odaberite jezike na koje želite prevesti ovaj članak. Jezici koji su već prevedeni bit će ponovno prevedeni u skicu za pregled.",
        "EMPTY": "Drugi jezici nisu dostupni.",
        "CONNECTED_BADGE": "Prevedeno",
        "CANCEL": "Otkaži",
        "TRANSLATE": "Prevedi",
        "SUCCESS": "Prijevod će uskoro započeti. Prevedeni članci uskoro će se pojaviti kao jezične varijante.",
        "ERROR": "Pokretanje prijevoda nije uspjelo"
      },
      "SLUG_DIALOG": {
        "TITLE": "Uredi URL članka",
        "DESCRIPTION": "Promijenite opisni dio sluga ovog članka. Stare poveznice i dalje rade — automatski preusmjeravaju ovamo.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "prvi-koraci",
        "PREFIX_HINT": "Brojčani prefiks trajni je identifikator i ne može se promijeniti.",
        "PREVIEW": "URL članka",
        "CANCEL": "Odustani",
        "SAVE": "Spremi",
        "SUCCESS": "URL članka je ažuriran",
        "ERROR": "Ažuriranje URL-a članka nije uspjelo"
      },
      "API": {
        "ERROR": "Pogreška prilikom spremanja članka"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Novi portal",
      "PORTALS": "Portali",
      "CREATE_PORTAL": "Izradite i upravljajte s više portala",
      "ARTICLES": "članci",
      "DOMAIN": "domena",
      "PORTAL_NAME": "Naziv portala"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Izradi novi portal",
      "DESCRIPTION": "Dajte naziv svom portalu i izradite jednostavan URL slug. Oboje možete kasnije izmijeniti u postavkama.",
      "CONFIRM_BUTTON_LABEL": "Izradi",
      "NAME": {
        "LABEL": "Ime",
        "PLACEHOLDER": "Korisnički priručnik",
        "MESSAGE": "Odaberite naziv za svoj portal.",
        "ERROR": "Ime je obavezno"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "korisnicki-prirucnik",
        "ERROR": "Slug je obavezan",
        "FORMAT_ERROR": "Koristite samo slova, brojeve i crtice, na primjer: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logotip",
          "IMAGE_UPLOAD_ERROR": "Sliku nije moguće prenijeti! Pokušajte ponovno",
          "IMAGE_UPLOAD_SUCCESS": "Slika je uspješno dodana. Kliknite na spremi promjene kako biste spremili logotip",
          "IMAGE_DELETE_SUCCESS": "Logotip je uspješno izbrisan",
          "IMAGE_DELETE_ERROR": "Logotip nije moguće izbrisati",
          "IMAGE_UPLOAD_SIZE_ERROR": "Veličina slike mora biti manja od {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Naslovna slika",
          "HELP_TEXT": "Opcionalna pozadinska slika pune širine prikazana iza centriranog okvira za pretraživanje na početnoj stranici centra za pomoć.",
          "IMAGE_UPLOAD_ERROR": "Prijenos slike nije uspio! Pokušajte ponovno",
          "IMAGE_UPLOAD_SUCCESS": "Slika je uspješno dodana. Kliknite na spremanje promjena da biste spremili naslovnu sliku",
          "IMAGE_DELETE_SUCCESS": "Naslovna slika je uspješno izbrisana",
          "IMAGE_DELETE_ERROR": "Nije moguće izbrisati naslovnu sliku",
          "IMAGE_UPLOAD_SIZE_ERROR": "Veličina slike mora biti manja od {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Članci početne stranice",
          "EMPTY": "Nijedan članak nije postavljen kao početna stranica. Postavite ga u svojstvima članka.",
          "HELP_TEXT": "Članak prikazan kao početna stranica za svaki jezik. Kliknite da biste ga otvorili ili ga uklonite da biste vratili zadanu početnu stranicu.",
          "REMOVE": "Ukloni",
          "REMOVE_SUCCESS": "Članak početne stranice je uklonjen",
          "REMOVE_ERROR": "Nije moguće ukloniti članak početne stranice"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv portala",
          "ERROR": "Ime je obavezno"
        },
        "HEADER_TEXT": {
          "LABEL": "Tekst zaglavlja",
          "PLACEHOLDER": "Tekst zaglavlja portala"
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov stranice",
          "PLACEHOLDER": "Naslov stranice portala"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Poveznica početne stranice",
          "PLACEHOLDER": "Poveznica početne stranice portala",
          "ERROR": "Nevažeći URL. Poveznica početne stranice mora počinjati s 'http://' ili 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portala"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget za razgovor uživo",
          "PLACEHOLDER": "Odaberite widget za razgovor uživo",
          "HELP_TEXT": "Odaberite widget za razgovor uživo koji će se prikazivati u vašem centru za pomoć"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Javno dostupno",
          "HELP_TEXT": "Učinite portal dostupnim svakome s poveznicom.",
          "OPTIONS": {
            "PUBLIC": "Da",
            "PRIVATE": "Ne"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Odredište poveznice",
          "HELP_TEXT": "Odaberite otvaraju li se poveznice unutar članaka u trenutnom prozoru ili u novom.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Trenutni prozor",
            "NEW_WINDOW": "Novi prozor"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Zadana veličina slike",
          "HELP_TEXT": "Veličina koja se primjenjuje na svaku sliku koju umetnete u članak. Odaberite Originalna za umetanje slika u njihovoj izvornoj veličini i zasebno odaberite veličinu za svaku sliku."
        },
        "BRAND_COLOR": {
          "LABEL": "Boja marke"
        },
        "CUSTOM_HTML": {
          "LABEL": "Prilagođeni HTML",
          "PLACEHOLDER": "<!-- Zalijepite ovdje svoj isječak za analitiku ili praćenje -->",
          "HELP_TEXT": "Umeće se na početku oznake <body> na svakoj stranici centra za pomoć. Koristite ga za Google Analytics, Google Tag Manager ili bilo koji drugi isječak za praćenje. Kod se prikazuje točno onako kako je unesen i ne provjerava se."
        },
        "SAVE_CHANGES": "Spremi promjene"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Prilagođena domena",
          "LABEL": "Prilagođena domena:",
          "DESCRIPTION": "Portal možete postaviti na prilagođenu domenu. Na primjer, ako je vaša web stranica yourdomain.com, a želite da vaš portal bude dostupan na docs.yourdomain.com, jednostavno to unesite u ovo polje.",
          "PLACEHOLDER": "Prilagođena domena portala",
          "EDIT_BUTTON": "Uredi prilagođenu domenu",
          "ADD_BUTTON": "Dodaj prilagođenu domenu",
          "DIALOG": {
            "ADD_HEADER": "Dodaj prilagođenu domenu",
            "EDIT_HEADER": "Uredi prilagođenu domenu",
            "ADD_CONFIRM_BUTTON_LABEL": "Dodaj domenu",
            "EDIT_CONFIRM_BUTTON_LABEL": "Ažuriraj domenu",
            "LABEL": "Prilagođena domena",
            "PLACEHOLDER": "Prilagođena domena portala",
            "ERROR": "Prilagođena domena je obavezna"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS konfiguracija",
            "DESCRIPTION": "Prijavite se na račun kod svog DNS pružatelja usluge i dodajte CNAME zapis u nastavku za svoju poddomenu.",
            "HELP_TEXT": "Nakon što to učinite, možete se obratiti našoj podršci kako biste zatražili automatski generirani SSL certifikat.",
            "CONFIRM_BUTTON_LABEL": "Razumijem!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Izbriši {portalName}",
          "HEADER": "Izbriši portal",
          "DESCRIPTION": "Trajno izbriši ovaj portal. Ova radnja je nepovratna",
          "DIALOG": {
            "HEADER": "Jeste li sigurni da želite izbrisati {portalName}?",
            "DESCRIPTION": "Ovo je trajna radnja koja se ne može poništiti.",
            "CONFIRM_BUTTON_LABEL": "Izbriši"
          }
        },
        "EDIT_CONFIGURATION": "Uredi konfiguraciju"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je uspješno izrađen",
          "ERROR_MESSAGE": "Portal nije moguće izraditi"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je uspješno ažuriran",
          "ERROR_MESSAGE": "Portal nije moguće ažurirati"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Privici",
      "DRAFT_BADGE": "Skica",
      "ADD_BUTTON": "Dodaj datoteku",
      "DROP_HERE": "Povucite i ispustite datoteke ovdje",
      "COPY_LINK": "Kopiraj poveznicu",
      "LINK_COPIED": "Poveznica kopirana u međuspremnik",
      "COPY_FAILED": "Kopiranje poveznice nije uspjelo",
      "DELETE": "Izbriši",
      "CANCEL": "Odustani",
      "QUEUED": "U redu čekanja",
      "UPLOADING": "Prijenos u tijeku",
      "UPLOAD_FAILED": "Prijenos datoteke nije uspio",
      "FILE_TOO_LARGE": "Datoteka prelazi ograničenje veličine od 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Rječnik prijevoda",
        "DESCRIPTION": "Pojmovi definirani ovdje dodaju se u AI prompt za prijevod kako bi se uvijek prevodili na isti način. Ključni pojam napisan je na {locale}."
      },
      "NEW_TERM": "Novi pojam",
      "EMPTY_STATE": {
        "TITLE": "Još nema pojmova u rječniku",
        "SUBTITLE": "Dodajte pojam i njegov prijevod za svaki jezik. Kada se članak prevodi, ovi se pojmovi primjenjuju kako bi terminologija vašeg proizvoda ostala dosljedna."
      },
      "LIST": {
        "TERM": "Pojam",
        "TRANSLATIONS": "Prijevodi",
        "ACTIONS": "Radnje"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Dodaj pojam",
          "EDIT": "Uredi pojam",
          "DESCRIPTION": "Pojam u nastavku primjenjuje se prilikom AI prevođenja članaka vašeg centra za pomoć.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Primarni jezik"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Pojam ({locale})",
            "PLACEHOLDER": "Sandučić",
            "ERROR": "Pojam je obavezan"
          },
          "DESCRIPTION": {
            "LABEL": "Kontekst / napomene (neobavezno)",
            "PLACEHOLDER": "Kada i kako se ovaj pojam koristi, kako bi se prevoditelju pomoglo razriješiti dvosmislenost."
          },
          "TRANSLATIONS": "Prijevodi",
          "TRANSLATION_PLACEHOLDER": "Ostavite prazno kako bi AI slobodno preveo",
          "AUTO_TRANSLATE": {
            "BUTTON": "Automatski prevedi sve",
            "CONFIRM": "Prevesti na {count} jezika pomoću AI-ja?",
            "CONFIRM_BUTTON": "Prevedi",
            "CANCEL": "Odustani",
            "SUCCESS": "Prijevodi generirani — pregledajte i spremite",
            "ERROR": "Automatsko prevođenje nije uspjelo, pokušajte ponovno"
          }
        },
        "BUTTONS": {
          "CREATE": "Dodaj pojam",
          "EDIT": "Spremi",
          "CANCEL": "Odustani"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Pojam je uspješno dodan",
            "ERROR_MESSAGE": "Pojam nije moguće dodati, pokušajte ponovno"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Pojam je uspješno ažuriran",
            "ERROR_MESSAGE": "Pojam nije moguće ažurirati, pokušajte ponovno"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Izbriši pojam",
          "DESCRIPTION": "Jeste li sigurni da želite izbrisati ovaj pojam? Više se neće primjenjivati prilikom prevođenja.",
          "CONFIRM": "Izbriši"
        },
        "API": {
          "SUCCESS_MESSAGE": "Pojam je uspješno izbrisan",
          "ERROR_MESSAGE": "Pojam nije moguće izbrisati, pokušajte ponovno"
        }
      }
    }
  }
}
